import { Injectable, signal } from '@angular/core';

/**
 * Coordinates data refresh across the worker absences screen (absences list,
 * illness list and absence limits). Provided per screen instance in
 * {@link AbsencesComponent} so all sibling lists share a single refresh signal.
 */
@Injectable()
export class AbsencesRefreshService {
  readonly refreshToken = signal(0);

  refresh(): void {
    this.refreshToken.update((value) => value + 1);
  }
}
